import { c as createCommonjsModule } from './common/_commonjsHelpers-8c19dec8.js';

var entity = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENTITY_ID = Symbol.for('Entity ID');
exports.ENGINE = Symbol.for('Engine');
exports.PROXY = Symbol.for('Entity Proxy');
exports.DELETED_PROPS = Symbol.for('Contains removed components (properties)');
const IGNORED_SYMBOLS = [exports.ENGINE, exports.PROXY];
exports.EntityProxyHandler = {
    set(entity, prop, value) {
        const engine = entity[exports.ENGINE];
        const voidToDelete = engine === null || engine === void 0 ? void 0 : engine.options.deleteVoidProps;
        const needDelete = voidToDelete && typeof value === 'undefined';
        if (needDelete) {
            // @ts-ignore
            return this.deleteProperty(entity, prop);
        }
        // We should trigger update when new property added
        const isIgnoredSymbol = typeof prop === 'symbol' && IGNORED_SYMBOLS.some(x => x === prop);
        const needUpdate = !isIgnoredSymbol && ((engine === null || engine === void 0 ? void 0 : engine.isWatchedProperty(prop)) || !(prop in entity));
        Reflect.set(entity, prop, value);
        if (needUpdate) {
            engine === null || engine === void 0 ? void 0 : engine._markEntityChanged(entity);
        }
        return true;
    },
    deleteProperty(entity, prop) {
        var _a;
        // @ts-ignore
        entity[exports.DELETED_PROPS].set(prop, entity[prop]);
        // @ts-ignore
        delete entity[prop];
        (_a = entity[exports.ENGINE]) === null || _a === void 0 ? void 0 : _a._markEntityChanged(entity);
        return true;
    }
};
/**
 * Ensures that entity is proxified
 */
exports.getEntity = (candidate) => {
    if (exports.isEntity(candidate)) {
        return candidate;
    }
    else if (exports.isEntityProjection(candidate)) {
        return candidate[exports.PROXY];
    }
    // const entity: IEntity = { ...candidate } as IEntity;
    const entity = candidate;
    const proxy = new Proxy(entity, exports.EntityProxyHandler);
    entity[exports.PROXY] = proxy;
    entity[exports.DELETED_PROPS] = new Map();
    return proxy;
};
exports.isEntityProjection = (entity) => {
    if (!entity)
        return false;
    return exports.PROXY in entity && (entity[exports.PROXY] !== entity);
};
exports.isEntity = (entity) => {
    if (!entity) {
        return false;
    }
    return exports.PROXY in entity && (entity[exports.PROXY] === entity);
};

});

var auxiliary = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = {
    info(...args) {
        console.log(...args);
    },
    warn(...args) {
        console.warn(...args);
    },
    error(...args) {
        console.error(...args);
    },
    verbose(...args) {
        console.log(...args);
    },
};

});

var system = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });


class System {
    constructor(requirements = null, ...tail) {
        this.enabled = true;
        this.priority = 5;
        this._requirements = null;
        this._entitiesInitialized = false;
        this._testFunctionCache = new Map();
        if (tail.length) {
            auxiliary.logger.warn(`System doesn't expect multiple arguments. For multi-component query - group components in array.\nextra args:`, tail);
        }
        if (requirements) {
            this.setRequirements(requirements);
        }
    }
    /**
     * Defines list(s) of entities with required components.
     * For example:
     * ```js
     * [ 'componentName1', 'componentName2' ]
     * ```
     *
     * results in array of entities which
     * have componentName1 and componentName2 components in them
     *
     * ```js
     * {
     *   entityList1: [ 'componentName1', 'componentName2' ],
     *   entityList2: [ 'componentName3' ]
     * }
     * ```
     *
     * Such requirement will produce an object with
     * two independent lists:
     * ```js
     * {
     *   entityList1: [entity1, entity2, ...]
     *   entityList2: [...]
     * }
     * ```
     *
     * You can also pass a `function` instead of `string`/`symbol`
     * to add custom selector logic.
     * Be aware: runtime checks are performed only if entity was marked as changed.
     *
     * Passing a single value will wrap it into an array.
     * For example:
     * ```js
     * 'componentName1'
     * ```
     * Transforms into
     * ```js
     * ['componentName`]
     * ```
     */
    get requirements() {
        return this._requirements;
    }
    set requirements(value) {
        this.setRequirements(value);
    }
    setRequirements(value) {
        if (!value) {
            this._requirements = null;
            return;
        }
        if (typeof value === 'string' || typeof value === 'symbol' || typeof value === 'function') {
            this._requirements = [value];
            return;
        }
        if (value instanceof Array) {
            this._requirements = value;
            return;
        }
        value = value;
        for (const [key, constr] of Object.entries(value)) {
            if (typeof constr === 'string' || typeof constr === 'symbol' || typeof constr === 'function') {
                value[key] = [constr];
            }
        }
        this._requirements = value;
    }
    _initEntityProxy() {
        if (System.EntitiesIsList(this._requirements, this._entityStore)) {
            // @ts-ignore
            this._entityProxy = null;
            return;
        } //else {
        if (!this._entityStore) {
            return;
        }
        this._entityProxy = new Proxy(this._entityStore, {
            get: (target, p, receiver) => {
                return this.getEntities(p);
            }
        });
        return this._entityProxy;
    }
    get entities() {
        if (System.RequirementsIsList(this._requirements)) {
            return this.getEntities();
        }
        if (!this._entityProxy) {
            this._initEntityProxy();
        }
        if (this._entityProxy) {
            return this._entityProxy;
        }
        return [];
    }
    /**
     * Called from `Engine.prototype.addSystem` method
     */
    initialize() {
        this._initEntities();
    }
    _initEntities() {
        if (this._entitiesInitialized) {
            return;
        }
        this._entitiesInitialized = true;
        if (this._requirements === null) {
            return;
        }
        if (!System.RequirementsIsList(this._requirements)) {
            this._entityStore = {};
            for (const key of Object.keys(this._requirements)) {
                this._entityStore[key] = new Set();
            }
        }
        else {
            this._entityStore = new Set();
        }
    }
    setEngine(engine) {
        this._engine = engine;
    }
    getEngine() {
        return this._engine;
    }
    update(dt) { }
    ;
    _getTestFunction(requirementList = []) {
        const cacheEntry = this._testFunctionCache.get(requirementList);
        if (cacheEntry) {
            return cacheEntry;
        }
        const tests = requirementList.map(predicate => {
            if (typeof predicate === 'string' || typeof predicate === 'symbol') {
                return (entity) => predicate in entity;
            }
            else if (typeof predicate === 'function') {
                return predicate;
            }
        }).filter((x) => !!x);
        const testFn = (entity) => {
            return tests.every(test => test(entity));
        };
        this._testFunctionCache.set(requirementList, testFn);
        return testFn;
    }
    /**
     * Checks entity for eligibility for the system
     * Adds or removes it from system's entity list.
     * @param entity
     */
    refreshEntityStatus(entity) {
        const { _requirements } = this;
        if (_requirements === null) {
            return;
        }
        // Single collection
        if (System.RequirementsIsList(_requirements) && System.EntitiesIsList(_requirements, this._entityStore)) {
            if (this.isEntityMeetsRequirementList(entity, _requirements)) {
                this.addEntity(entity);
            }
            else {
                this.removeEntity(entity);
            }
        }
        else if (typeof _requirements === 'object') { // Collections map
            for (const [collectionName, requirement] of Object.entries(_requirements)) {
                if (!System.RequirementsIsList(requirement)) {
                    auxiliary.logger.warn(`Wrong requirement "${collectionName}":`, requirement, 'in', this);
                    continue;
                }
                if (this.isEntityMeetsRequirementList(entity, requirement)) {
                    this.addEntity(entity, collectionName);
                }
                else {
                    this.removeEntity(entity, collectionName);
                }
            }
        }
        else {
            throw new Error(`Incorrect requirements type. Expected Array or Object got ${typeof _requirements}`);
        }
    }
    ;
    isEntityMeetsRequirementList(entity, requirementList) {
        const testFunction = this._getTestFunction(requirementList);
        return testFunction === null || testFunction === void 0 ? void 0 : testFunction(entity);
    }
    static EntitiesIsList(requirements, entities) {
        return this.RequirementsIsList(requirements);
    }
    entitiesIsList(entities) {
        return System.EntitiesIsList(this.requirements, entities);
    }
    static RequirementsIsList(requirements) {
        return requirements instanceof Array;
    }
    addEntity(entity, collectionName) {
        if (!System.EntitiesIsList(this._requirements, this._entityStore)) {
            if (typeof collectionName === 'string') {
                const collection = this._entityStore[collectionName];
                if (!collection.has(entity)) {
                    collection.add(entity);
                    this.onEntityAdded(entity, collectionName);
                }
            }
            else {
                throw new Error('Collection name is not specified.');
            }
        }
        else {
            const collection = this._entityStore;
            if (!collection.has(entity)) {
                collection.add(entity);
                this.onEntityAdded(entity);
            }
        }
    }
    onEntityAdded(entity, collectionName) { }
    getEntities(collectionName) {
        if (!this._requirements && this._engine) {
            return this._engine.entities.values();
        }
        if (typeof collectionName === 'string') {
            if (!System.EntitiesIsList(this._requirements, this._entityStore)) {
                return this._entityStore[collectionName];
            }
            throw new Error(`System has a single collection.`);
        }
        return this._entityStore;
    }
    /**
     * Convenience method for retrieving a single (first) entity
     */
    getEntity(collectionName) {
        var _a, _b;
        const entities = this.getEntities(collectionName);
        if (entities) {
            const iterator = (_a = entities[Symbol.iterator]) === null || _a === void 0 ? void 0 : _a.call(entities);
            return (_b = iterator === null || iterator === void 0 ? void 0 : iterator.next()) === null || _b === void 0 ? void 0 : _b.value;
        }
    }
    /**
     * Used for iteration through all collections
     */
    *getAllEntityCollections() {
        if (!this._entityStore) {
            return;
        }
        if (System.EntitiesIsList(this._requirements, this._entityStore)) {
            yield this._entityStore;
        }
        else { // collection map
            yield* Object.values(this._entityStore);
        }
    }
    /**
     * Used to determine if the system should be update by Engine next tick
     */
    isQualifiedForUpdate() {
        if (!this._entityStore) {
            return true; // Systems without requirements are `global`
        }
        if (System.EntitiesIsList(this._requirements, this._entityStore)) {
            return !!this._entityStore.size;
        }
        else { // collection map
            for (const list of Object.values(this._entityStore)) {
                if (list.size) {
                    return true;
                }
            }
            return false;
        }
    }
    removeEntity(entity$1, collectionName) {
        if (!this._entityStore) {
            return false;
        }
        // Remove from a specific collection
        if (typeof collectionName === 'string') {
            if (!System.EntitiesIsList(this._requirements, this._entityStore)) {
                const store = this._entityStore[collectionName];
                if (store.has(entity$1)) {
                    store.delete(entity$1);
                    this.onEntityRemoved(entity$1, entity$1[entity.DELETED_PROPS], collectionName);
                    return true;
                }
                return false;
            }
            throw new Error('Tried to access entity list with a key but its a single collection');
        }
        // Remove from all collections otherwise
        if (System.EntitiesIsList(this.requirements, this._entityStore)) {
            if (!this._entityStore.has(entity$1))
                return false;
            this._entityStore.delete(entity$1);
            this.onEntityRemoved(entity$1, entity$1[entity.DELETED_PROPS]);
            return true;
        }
        let wasInSystem = false;
        for (const [collectionName, collection] of Object.entries(this._entityStore)) {
            if (!collection.has(entity$1))
                continue;
            collection.delete(entity$1);
            wasInSystem = true;
            this.onEntityRemoved(entity$1, entity$1[entity.DELETED_PROPS], collectionName);
        }
        return wasInSystem;
    }
    /**
     * In case complete entity removal (i.e.: entity removed from Engine) collectionName is not passed
     */
    onEntityRemoved(entity, deletedComponents, collectionName) {
    }
    getComponentFrom(entity$1, key) {
        // @ts-ignore
        return entity$1[key] || entity$1[entity.DELETED_PROPS].get(key);
    }
}
exports.System = System;
exports.isSystem = (system) => {
    return system instanceof System;
};

});

var simplifiedSystem = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

exports.dummyUpdateMethod = (dt) => {
};
/**
 * Used for simplified handler declaration via engine.add()
 */
class SimplifiedSystem extends system.System {
    constructor(update, requirements = null) {
        super(requirements);
        this._updateHandler = exports.dummyUpdateMethod;
        this.update = (dt) => {
            this._updateHandler(dt);
        };
        this._updateHandler = update;
        this.requirements = requirements;
    }
}
exports.SimplifiedSystem = SimplifiedSystem;

});

var engine = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });



class Engine {
    constructor(options = {}) {
        this._systems = [];
        this._entitiesStore = new Set();
        this._dt = 0;
        this._entitiesRefreshQueue = new Set();
        this._entitiesToAddQueue = new Set();
        this._watchedProperties = new Set();
        this.entityIdCounter = 1;
        this.options = {
            lazyEntityRefresh: true,
            lazyEntityAdd: false,
            deleteVoidProps: false,
            ...options
        };
        this.add = this.add.bind(this);
    }
    get entities() {
        return this._entitiesStore;
    }
    get dt() {
        return this._dt;
    }
    getNextEntityID() { return this.entityIdCounter++; }
    /**
     * Runs all registered systems with provided time delta value
     */
    update(dt) {
        this._dt = dt;
        this.processAddQueue();
        this.processChangedQueue();
        for (const system of this._systems) {
            this.updateSystem(system);
        }
    }
    ;
    updateSystem(system) {
        if (!system.enabled || !system.isQualifiedForUpdate())
            return;
        try {
            system.update(this._dt);
        }
        catch (err) {
            console.error(err);
            system.enabled = false;
        }
    }
    add(obj = {}, ...args) {
        if (obj instanceof Array) {
            return obj.map(x => this.add(x));
        }
        if (obj instanceof Promise) {
            // @ts-ignore
            return obj.then(x => this.add(x));
        }
        if (obj instanceof system.System) {
            return this.addSystem(obj);
        }
        else if (typeof obj === 'function') {
            if (Engine.isSystemConstructor(obj)) {
                return this.addSystemClass(obj, ...args);
            }
            else { // handler function
                const [requirements] = args;
                return this.addHandler(obj, requirements);
            }
        }
        else {
            return this.addEntity(obj);
        }
    }
    addEntity(candidate) {
        if (!candidate) {
            candidate = {};
        }
        const entity$1 = entity.getEntity(candidate);
        if (this._entitiesStore.has(entity$1) || this._entitiesToAddQueue.has(entity$1)) {
            return entity$1;
        }
        const preAssignedEngine = entity$1[entity.ENGINE];
        if (preAssignedEngine && preAssignedEngine !== this) {
            preAssignedEngine.removeEntity(entity$1);
        }
        entity$1[entity.ENGINE] = this;
        entity$1[entity.ENTITY_ID] = this.getNextEntityID();
        if (this.options.lazyEntityAdd) {
            this._entitiesToAddQueue.add(entity$1);
        }
        else {
            this._entitiesStore.add(entity$1);
            this._markEntityChanged(entity$1);
        }
        return entity$1;
    }
    addHandler(updateFn, requirements) {
        const system = new simplifiedSystem.SimplifiedSystem(updateFn, requirements);
        return this.addSystem(system);
    }
    addSystemClass(Class, ...args) {
        return this.addSystem(new Class(...args));
    }
    addSystem(system) {
        system.setEngine(this);
        system.initialize();
        this._systems.push(system);
        for (const entity of this._entitiesStore) {
            system.refreshEntityStatus(entity);
        }
        this._systems.sort((a, b) => {
            return a.priority - b.priority;
        });
        return system;
    }
    processAddQueue() {
        for (const entity of this._entitiesToAddQueue) {
            this.entities.add(entity);
            this._markEntityChanged(entity);
        }
        this._entitiesToAddQueue.clear();
    }
    /**
     * Marks entity for affiliation state refresh.
     * Performs refresh immediately or postponed when options.lazyEntityRefresh === true
     */
    _markEntityChanged(entity$1, lazy = this.options.lazyEntityRefresh) {
        entity$1 = entity.getEntity(entity$1);
        if (lazy) {
            this._entitiesRefreshQueue.add(entity$1);
        }
        else {
            this.refreshEntity(entity$1);
        }
    }
    processChangedQueue() {
        for (const entity of this._entitiesRefreshQueue) {
            this.refreshEntity(entity);
        }
    }
    /**
     * Watched property will trigger _markEntityChanged() on it's value set.
     * Warn: setting the same value also triggers the behavior
     */
    addWatchedProperty(prop) {
        this._watchedProperties.add(prop);
    }
    removeWatchedProperty(prop) {
        this._watchedProperties.delete(prop);
    }
    isWatchedProperty(prop) {
        return this._watchedProperties.has(prop);
    }
    /**
     * Recalculates entity affiliation to systems
     */
    refreshEntity(entity$1) {
        var _a, _b;
        entity$1 = entity.getEntity(entity$1);
        this._entitiesRefreshQueue.delete(entity$1);
        for (const system of this._systems) {
            system.refreshEntityStatus(entity$1);
        }
        if ((_a = entity$1[entity.DELETED_PROPS]) === null || _a === void 0 ? void 0 : _a.size) {
            (_b = entity$1[entity.DELETED_PROPS]) === null || _b === void 0 ? void 0 : _b.clear();
        }
    }
    removeEntity(entity$1) {
        entity$1 = entity.getEntity(entity$1);
        this._entitiesStore.delete(entity$1);
        this._entitiesRefreshQueue.delete(entity$1);
        this._entitiesToAddQueue.delete(entity$1);
        delete entity$1[entity.ENGINE];
        for (const system of this._systems) {
            system.removeEntity(entity$1);
        }
    }
    removeSystem(system) {
        const index = this._systems.indexOf(system);
        this._systems.splice(index, 1);
    }
    static isSystemConstructor(fn) {
        return fn.prototype instanceof system.System;
    }
}
exports.Engine = Engine;

});

var lib = createCommonjsModule(function (module, exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(engine);
__export(system);
__export(entity);
__export(simplifiedSystem);

});

var ENGINE = lib.ENGINE;
var Engine = lib.Engine;
var System = lib.System;
export { ENGINE, Engine, System };
